export default __webpack_public_path__ + "static/media/thai-oil-logo.6c92c9b4.svg";